<div id="pricing" class="services-area pt-100 pb-70">
    <div class="container">
        <div class="row">
        <div class="section-title col-lg-4 col-sm-12 text-left d-flex align-items-end mb-4 ml-0">
            <div>
                <h2 [innerHTML]="pricingConfig.title | linebreaks"></h2>
                <p [innerHTML]="pricingConfig.description | linebreaks"></p>
                <a [href]="pricingConfig.buttonUrl" class="btn btn-primary rounded-pill px-4 py-2 rounded-pill-btn">
                    {{ pricingConfig.buttonText }}
                </a>
            </div>
        </div>
        <div class="col-lg-8 col-sm-12">
            <df-carousel>
                <img *ngFor="let slide of pricingConfig.slides" [src]="slide.url" [alt]="slide.name" class="imgClass">
            </df-carousel>
        </div>
    </div>
</div>
